export const environment = {
    production: false,
    baseUrlPing: 'https://openam-dev.day1cloud.com/am/',
    journeyOptions: {
        "Review":"multi-factor-authn",
        "default":"multi-factor-authn",
        "Allow": "simple-authn",
        "myprofile":"multi-factor-authn",
    },
    cookie: 'a1d213d00e6ea91',
    tyc: 'https://login.day1cloud.com/tyc',
    clientId: 'spark',
    realmPath: 'alpha',
    scope: 'openid profile email mail me.read fr:idm:*',
    apiURL: 'https://api-qa.day1cloud.com/api',
    oauth: {
        clientId: 'MyProfile',
        issuer: 'https://risk-detection-router-api-qa-ct5ogq.rajrd4-1.usa-e1.cloudhub.io'
    }
}